import React from "react";

const PrintDocumentAsCentralText = (props) => {
  const {styles} = props;
  const {View, Text} = window.ReactPdfRenderer;
  return (
    <View style={[styles.marginT30, styles.main]}>
      <Text>Buyer(s) listed above hereby jointly and severally agrees to purchase the goods and/or services listed below, in accordance with the prices and terms described on this Specification Sheet and the front and the reverse of the accompanying CUSTOM REMODELING AGREEMENT, of which this Specification Sheet is a part.</Text>
    </View>
  )
};


export default PrintDocumentAsCentralText
